export const jsmContextualRovoPromptSurface = 'rovoQuickActions';
